import { z } from "zod";
import { badgeCriteriaTypeSchema } from "./enum.js";

export const badgeSummarySchema = z.object({
	id: z.string(),
	code: z.string(),
	label_key: z.string(),
	description_key: z.string(),
	icon: z.string(),
	criteria_type: badgeCriteriaTypeSchema,
	criteria_threshold: z.number().int().nonnegative(),
	display_order: z.number().int(),
	unlocked_at: z.number().int().positive().nullable(),
});

export type BadgeSummary = z.infer<typeof badgeSummarySchema>;

export const badgeListResponseSchema = z.object({
	user_id: z.string(),
	unlocked_count: z.number().int().nonnegative(),
	total_count: z.number().int().nonnegative(),
	badges: z.array(badgeSummarySchema),
});

export type BadgeListResponse = z.infer<typeof badgeListResponseSchema>;

export const badgeListQuerySchema = z.object({
	user_id: z.string().optional(),
});

export type BadgeListQuery = z.infer<typeof badgeListQuerySchema>;
